import { i18n } from "@/app/i18n";
import {
  attachIframeBlockerHandlers,
  setCampaignCookieFromParams,
  setExternalLinksToNewTab,
} from "@/common/utils";
import "@/scss/main.scss";
import $ from "jquery";
import { createApp } from "vue";
import { App } from "./app/App";
import { formSettings } from "./app/settings";
import { RegionHelper } from "./common/region_helper";
import { RecaptchaPlugin } from "./components/recaptcha";

RegionHelper.setupLocale();

setCampaignCookieFromParams();

// this is for the 2simple office only which bypasses the load balancer redirection to HTTPS
if (location.host === "2simple.com" && location.protocol === "http:") {
  window.location.href = location.href.replace(/^http:/, "https:");
}

// Mount Vue apps by finding their relative DOM elements.
document.addEventListener("DOMContentLoaded", () => {
  attachIframeBlockerHandlers();
  setExternalLinksToNewTab();

  createApp(App)
    .use(i18n)
    .use(RecaptchaPlugin, { sitekey: formSettings.recaptchaSiteKey })
    .mount("#app");
});

$(document).ready(() => {
  $(document.body).removeClass("cloaked");
});
$(document).ready(function () {
  // fix links in Wagtail rich text editors, if the link contains 2simple.com remove the target
  // otherwise give it a target
  $(".rich-text a").each(function () {
    const href = $(this).attr("href");
    if (href) {
      if (/2simple.com/.test(href) || !/^http(s)?:/.test(href)) {
        $(this).attr("target", "");
      } else {
        $(this).attr("target", "_new");
      }
    }
  });

  // stupid fix - support.2simpleweb.com does not support HTTPS at the moment so we switch to downloads
  Array.from(document.getElementsByTagName("a")).forEach((linkEl) => {
    if (!linkEl.href) {
      return;
    }
    linkEl.href = linkEl.href.replace(
      "support.2simpleweb.com",
      "downloads.2simple.com"
    );
  });
});

// Custom header
// TODO: move into component.
if ($(document.body).hasClass("wagtail")) {
  $(window).scroll(function () {
    if ($(window).scrollTop() !== 0) {
      $("body.wagtail")
        .css("margin-top", $("#common-header").height() + "px")
        .addClass("scrolling");
    } else {
      $("body.wagtail").removeClass("scrolling").css("margin-top", "");
    }
  });
}
